import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./reducers/AuthSlice/AuthSlice";
import userReducer from "./reducers/UserSlice/UserSlice";
import propertiesReducer from "./reducers/Properties/PropertiesSlice";
import paymentSlice from "./reducers/Payments/PaymentReducer";
import ChatSlice from "./reducers/ChatReducer/ChatSlice";
import searchSlice from "./reducers/Search/SearchSlice";
import googleReviewsReducer from "./reducers/GoogleReviews/GoogleReviewsSlice";
import experiencesReducer from "./reducers/Experiences/ExperiencesSlice"

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "search", "user", "payment", "chat"], 
};

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  property: propertiesReducer,
  googleReviews: googleReviewsReducer, 
  payment: paymentSlice,
  chat: ChatSlice,
  search: searchSlice,
  experiences: experiencesReducer, 
});

const rootReducerWithLogout = (state: any, action: any) => {
  if (action.type === "auth/logout" || action.type === "auth/killSession") {
    storage.removeItem("persist:root");
    return rootReducer(undefined, action);
  }
  return rootReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducerWithLogout);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const persistor = persistStore(store);
